import { isBoExternal } from '@sh4res/bo-common/utils/env';

export type ResourceBasePath = 'b2b/' | '';

export function useResourceBasePath(): ResourceBasePath {
  return isBoExternal() ? '' : 'b2b/';
}
